import React from 'react';

/**
 * Elevated or flat surface container — uses .lex-card token classes.
 */
const Card = ({ children, className = '', variant = 'elevated', padded = true }) => {
  const classes = [
    'lex-card',
    variant === 'flat' ? 'lex-card--flat' : 'lex-card--elevated',
    padded ? 'lex-card--padded' : '',
    className,
  ].filter(Boolean).join(' ');

  return <div className={classes}>{children}</div>;
};

export default Card;
